import React, { useEffect, createRef, useState } from 'react'
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { NEW, VIEW, UPDATE } from '../../assets/Constants/actionsTypes'
import { useTranslation } from 'react-i18next';

const SPFunctionsModal = (props) => {
  // * we call the hook to make translations
  const {t} = useTranslation('common');

  // * we create a reference for the modal
  const window = createRef();

  //// const [title, setTitle] = useState('');
  
  // * defines whether or not to display the save button
  const [showSave, setShowSave] = useState(false);

  // * defines whether we are in update mode
  const [isUpdate, setIsUpdate] = useState(false);

  // * here you define the variables linked to the inputs
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  /**
   * here you define the configuration that the modal will have. this depends on the type with which it was opened.
   */
  useEffect(() => {
    
    if (props.type === NEW) {
      setShowSave(true);
      setName('');
      setDescription('');
    } else {
      if (props.data) {
        setName(props.data.name);
        setDescription(props.data.description);
        if (props.type === VIEW) {

          setShowSave(false)
        } else {
          if (props.type === UPDATE) {
            setShowSave(true);
            setIsUpdate(true);
          }
        }
      } else {
        props.toggleWindow();
      }
    }

  }, [props])

  // * with this we make sure to always hide the maximize and minimize buttons.
  useEffect(() => {
    if (window) {
      hideButtons();
    }
  })

  // * with this we hide the maximize and minimize buttons.
  const hideButtons = () => {
    let maximizeButton = window.current.windowElement.querySelector(
      ".k-i-window-maximize"
    ).parentElement;
    maximizeButton.style.visibility = "hidden";

    let minimizeButton = window.current.windowElement.querySelector(
      ".k-i-window-minimize"
    ).parentElement;
    minimizeButton.style.visibility = "hidden";
  }

  return (
    <div className="">
      <Window
        className="ilo-k-window"
        initialHeight={500}
        modal={true}
        title={t('spFunction.modal_title')}
        resizable={false}
        draggable={false}
        doubleClickStageChange={false}
        onClose={() => {
          props.toggleWindow();
        }}
        ref={window}
      >
        <div className="container-fluid m-1">
          <div className="row">
            <div className="col-md-1" ></div>
            <div className="col-md-10">

              <div className="row justify-content-center mb-2">
                <label className={`col-10 col-form-label ${showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}`}>{t('spFunction.name_input')}</label>
                <div className="col-10">
                  <input
                    type="text"
                    disabled={!showSave || isUpdate}
                    className="form-control ilo-input ilo-modal-input"
                    placeholder={t('spFunction.name_input')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>

              <div className="row justify-content-center mb-2">
                <label className={`col-10 col-form-label ilo_lbl_general`}>{t('spFunction.description_input')}</label>
                <div className="col-10">
                  <textarea
                    disabled={!showSave}
                    className="form-control ilo-input ilo-modal-input"
                    rows="10"
                    placeholder={t('spFunction.description_input')}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <WindowActionsBar layout="end">
                {showSave &&
                  <button
                    onClick={() => {
                      const data = {
                        spFunctionId: isUpdate ? props.data.spFunctionId : 0,
                        name,
                        description
                      }
                      props.onSave(data)
                    }}
                    className="btn btn-primary ilo-btn"
                  >{t('modals.save_btn')}</button>
                }

                <button onClick={props.toggleWindow} className="btn btn-primary ilo-btn">{showSave ? t('modals.cancel_btn') : t('modals.close_btn')}</button>
              </WindowActionsBar>

            </div>
            <div className="col-md-1" ></div>
          </div>
        </div>

      </Window>
    </div>
  )
}

export default SPFunctionsModal
